import { useMemo } from "react";
import { FaChevronRight, FaImages } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buildRawImageUrl } from "./installationConfigUtils";
import { InstallationPickerRow } from "./InstallationPickerSheet";

function getLatestCycleWithImages(cycleEntries) {
  const withImages = (cycleEntries || []).filter(
    (item) => item.log && (item.leftImage || item.rightImage),
  );
  if (withImages.length === 0) {
    return null;
  }

  return withImages.reduce((latest, current) => {
    const extractDateTime = (name) =>
      new Date(name.split("-camera-")[0].replace("_", ":").replace("_", ":"));
    return extractDateTime(latest.name) > extractDateTime(current.name)
      ? latest
      : current;
  });
}

function hasRecentImages(cycleEntries) {
  return Boolean(getLatestCycleWithImages(cycleEntries));
}

const InstallationVisualizationSection = ({
  routeCameraId,
  cycleEntries,
  divided = false,
  variant = "row",
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const subtitle = useMemo(() => {
    if (hasRecentImages(cycleEntries)) {
      return t("installation_visualization_menu_subtitle_ready");
    }
    return t("installation_no_recent_image");
  }, [cycleEntries, t]);

  const previewUrl = useMemo(() => {
    const latestEntry = getLatestCycleWithImages(cycleEntries);
    if (!latestEntry?.name) {
      return "";
    }
    return buildRawImageUrl(routeCameraId, latestEntry.name, "-L");
  }, [cycleEntries, routeCameraId]);

  const openRawVisualization = () => {
    history.push(`/app/installationdetails/${routeCameraId}/visualization`);
  };

  if (variant === "prominent") {
    return (
      <button
        type="button"
        className="installation-visualization-promo"
        onClick={openRawVisualization}
      >
        <div className="installation-visualization-promo-body">
          <span className="installation-visualization-promo-title">
            {t("installation_visualization_raw_title")}
          </span>
          <span className="installation-visualization-promo-subtitle">
            {subtitle}
          </span>
        </div>
        {previewUrl ? (
          <img
            src={previewUrl}
            alt=""
            className="installation-visualization-promo-preview"
          />
        ) : (
          <span className="installation-visualization-promo-icon" aria-hidden>
            <FaImages />
          </span>
        )}
        <FaChevronRight
          className="installation-visualization-promo-chevron"
          aria-hidden
        />
      </button>
    );
  }

  return (
    <InstallationPickerRow
      icon={FaImages}
      iconVariant="visualization"
      title={t("installation_visualization_raw_title")}
      subtitle={subtitle}
      onClick={openRawVisualization}
      divided={divided}
    />
  );
};

export default InstallationVisualizationSection;
